import BrowserCallNative from './BrowserCallNative.js';
import { getGtgj } from './gtgjInit.js';

export default class GaotieGuanjiaCallNative extends BrowserCallNative {
  static callNative(name, data) {
    if (!this[name]) {
      return Promise.reject(new Error(`${name}功能在享道App中暂时无法使用`));
    }
    return this[name](data);
  }

  static closeWebView() {
    return getGtgj().closeWebView();
  }
}
